import React, { useEffect, useState } from "react";
import Navbar from "../Navbar/Navbar";
import { API } from "../../Redux/actions/API";
import Table from "../Table/Table";
import Table_Buttons from "../Table_Button/Table_button";
import { useParams } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { updateAuth } from "../../Redux/actions/AdminAuthSlice";
import { useNavigate } from "react-router-dom";
import * as FileSaver from "file-saver";
import * as XLSX from "xlsx";
import Spinner from "../Spinner/Spinner";
import { toast } from "react-toastify";

function PendingUsdtRequest() {
  const { userId, jwt_token } = useSelector((state) => state.Auth);

  // const { userId } = useSelector((state) => state.Auth);
  //   const jwt_token = sessionStorage.getItem("jwt_token");
  const dispatch = useDispatch();
  const navigate = useNavigate();

  let user = "";

  const [isLoading, setisLoading] = useState(false);
  const [currentPage, setcurrentPage] = useState(1);
  const [listPerpage, setlistPerpage] = useState(50);
  const [leftreferralApi, setleftreferralApi] = useState([]);
  const [search, setSearch] = useState(user);
  const [reason, setReason] = useState("");

  const [position, setPosition] = useState("0");
  const [Level, setLevel] = useState("0");
  const [todate, setTodate] = useState("");
  const [formdate, setFromdate] = useState("");

  let arrayLeft = [];
  const [TotalBet, setTotalBet] = useState("0");
  const [Search_UserId, setSearch_UserId] = useState("");

  const referral_API = async () => {
    try {
      let responceRight = await API?.post(
        `GetPendingFundRequestList`,
        {
          uid: Search_UserId.substring(2),
          loginid: userId,
        },
        {
          headers: {
            Authorization: jwt_token,
          },
        },
      );

      responceRight = responceRight?.data?.data[0];
      //console.log("res", responceRight);

      setleftreferralApi([]);
      let arrayLeft = [];
      let totalAmount = 0;

      responceRight.forEach((item, index) => {
        arrayLeft.push({
          sr: index + 1,
          UserId: `${item.uid}`,
          f_name: item.f_name,
          amount: item.amount,
          utrno: item.utrno,
          date: item.date,
          upitype: item.bankname,
          userAddress: item.userAddress,
          Ftype: item.Ftype,
          upinumber: item.accountnumber,
          // approve: (
          //   <button
          //     type="button"
          //     className="btn btn-success btn-sm"
          //     onClick={(e) => OnHandleClickApprove(item.id)}
          //   >
          //     Approve
          //   </button>
          // ),
          // cancel: (
          //   <button
          //     type="button"
          //     className="btn btn-danger btn-sm"
          //     onClick={(e) => OnHandleClickCancel(item.id)}
          //   >
          //     Cancel
          //   </button>
          // ),
          approve: (
            <button
              type="button"
              className="btn btn-success btn-sm"
              onClick={(e) => {
                const remark = e.target
                  .closest("tr")
                  .querySelector("input")?.value;

                OnHandleClick(item.id, 1, remark);
              }}
            >
              Approve
            </button>
          ),
          CancelRemark: (
            <input
              className="form-control"
              style={{ width: "120px", borderRadius: "13px" }}
              // onChange={(e) =>
              //   setcancelRemark((prev) => ({
              //     ...prev,
              //     [item.id]: e.target.value,
              //   }))
              // }
            />
          ),
          cancel: (
            <button
              type="button"
              className="btn btn-danger btn-sm"
              onClick={(e) => {
                const remark = e.target
                  .closest("tr")
                  .querySelector("input")?.value;

                OnHandleClick(item.id, 2, remark);
              }}
            >
              Cancle
            </button>
          ),
        });
        totalAmount = totalAmount + item.amount;
        setleftreferralApi(arrayLeft);
        setTotalBet(totalAmount);
      });
    } catch (e) {
      console.log("error Balance APi", e);
      if (
        e.response.data.showableMessage ==
        "Please login to access this resource"
      ) {
        dispatch(updateAuth({ AdminAuth: false, jwt_token: "", userId: null }));
        sessionStorage.clear();
        localStorage.clear();
        navigate("/");
      }
    } finally {
      setisLoading(false);
    }
  };

  const OnHandleClick = async (RowId, type, remarkFromInput = "") => {
    let confirm = window.confirm(
      `Are you sure, you want to ${
        type === 1 ? "approve" : type === 2 ? "reject" : ""
      }!!`,
    );
    if (!confirm) return;
    console.clear();
    console.log("cancelRemark-->", remarkFromInput);
    const remark = remarkFromInput;

    if (!remark || remark.trim() === "") {
      toast.error("Please Enter Remark!!");
      return;
    }
    let responceApprove = await API?.post(
      `PaidFundRequest`,
      {
        id: RowId,
        loginid: userId,
        type: type === 1 ? "status" : type === 2 ? "update" : "",
        reason: remark || "",
      },
      {
        headers: {
          Authorization: jwt_token,
        },
      },
    );
    responceApprove = responceApprove?.data?.data;

    //console.log("responceApprove", responceApprove);
    if (responceApprove.result == "success") {
      toast.success(
        type === 1 ? "Successfully Approved!!" : "Successfully Cancle!!",
      );
      setTimeout(() => window.location.reload(), 1000);
    } else {
      toast.info(responceApprove.result);
    }
  };

  // const OnHandleClickApprove = async (id) => {
  //   let confirm = window.confirm("Are you sure, you want to approve !!");
  //   if (confirm) {
  //     let responceApprove = await API?.post(
  //       `PaidFundRequest`,
  //       {
  //         id: id,
  //         loginid: userId,
  //       },
  //       {
  //         headers: {
  //           Authorization: jwt_token,
  //         },
  //       },
  //     );

  //     responceApprove = responceApprove?.data?.data;
  //     //console.log("responceApprove", responceApprove);
  //     if (responceApprove.result == "success") {
  //       toast.success("Approved Successfully !!");
  //       setTimeout(() => {
  //         window.location.reload();
  //       }, 1000);
  //     } else {
  //       toast.info(responceApprove.result);
  //     }
  //   }
  // };

  // const OnHandleClickCancel = async (id) => {
  //   let confirm = window.confirm("Are you sure, you want to cancel !!");
  //   if (confirm) {
  //     if (!reason || Object.keys(reason).length === 0) {
  //       toast.error("Enter Remark");
  //       return;
  //     }

  //     let responceApprove = await API?.post(
  //       `CancelFundRequest`,
  //       {
  //         id: id,
  //         loginid: userId,
  //         reason: reason,
  //       },
  //       {
  //         headers: {
  //           Authorization: jwt_token,
  //         },
  //       },
  //     );

  //     responceApprove = responceApprove?.data?.data;
  //     console.log("responceApprove", responceApprove);
  //     if (responceApprove.result == "success") {
  //       toast.success("Canceled Successfully !!");
  //       setTimeout(() => {
  //         window.location.reload();
  //       }, 1000);
  //     } else {
  //       toast.info(responceApprove.result);
  //     }
  //   }
  // };

  const referral_API_Export = async () => {
    setisLoading(true);
    try {
      let responceRight = await API?.post(
        `GetPendingFundRequestList`,
        {
          uid: Search_UserId.substring(2),
          loginid: userId,
        },
        {
          headers: {
            Authorization: jwt_token,
          },
        },
      );
      responceRight = responceRight?.data?.data[0];
      let arrayLeft = [];

      responceRight.forEach((item, index) => {
        arrayLeft.push({
          "User Id": `NC${item.uid}`,
          Name: item.f_name,
          Amount: item.amount,
          Ftype: item.Ftype,
          "Txn No.": item.utrno,
          "Requested Date": item.date,
          //"UPI Type": item.bankname,
          //"UPI Id": item.accountnumber,
        });
      });

      const fileName = `PendingUSDTBonusRequest`;
      const fileType =
        "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8";
      const fileExtension = ".xlsx";
      const ws = XLSX.utils.json_to_sheet(arrayLeft);
      const wb = { Sheets: { data: ws }, SheetNames: ["data"] };
      const excelBuffer = XLSX.write(wb, {
        bookType: "xlsx",
        type: "array",
      });
      const data = new Blob([excelBuffer], { type: fileType });
      FileSaver.saveAs(data, fileName + fileExtension);
    } catch (error) {
      console.log("Error While calling Myteam API", error);
      if (
        error.response.data.showableMessage ==
        "Please login to access this resource"
      ) {
        dispatch(updateAuth({ AdminAuth: false, jwt_token: "" }));
        sessionStorage.clear();
        localStorage.clear();
        navigate("/");
      }
    }
    setisLoading(false);
  };

  useEffect(() => {
    referral_API();
  }, [reason]);

  const indexOfLastPost = currentPage * listPerpage;
  const indexOfFirstPage = indexOfLastPost - listPerpage;
  const currentPostleft = leftreferralApi.slice(
    indexOfFirstPage,
    indexOfLastPost,
  );

  var [my_team, set_my_team] = new useState({
    cols: [
      { Header: "S.No.", accessor: "sr" },
      { Header: "User Id", accessor: "UserId" },
      // { Header: "Name", accessor: "f_name" },
      { Header: "Type", accessor: "Ftype" },
      { Header: "Amount", accessor: "amount" },
      { Header: "User Address", accessor: "userAddress" },
      { Header: "Txn No", accessor: "utrno" },
      { Header: "Requested Date", accessor: "date" },
      //{ Header: "UPI Type", accessor: "upitype" },
      //{ Header: "UPI Id", accessor: "upinumber" },
      { Header: "Remark", accessor: "CancelRemark" },
      { Header: "Approve", accessor: "approve" },
      // { Header: "Cancel", accessor: "cancel" },
    ],
  });

  return (
    <div>
      <Navbar />
       {userId === "1" ? (
      <div className="content-page">
        <div className="content">
          <div className="container">
            {/* <!-- Inline Form --> */}
            <div className="row">
              <div className="col-md-12">
                <div className="panel panel-primary">
                  <div className="panel-heading">
                    <h4 className="panel-title">
                      Pending Wallet Change Request
                    </h4>
                  </div>
                  <div
                    className="panel-body table-rep-plugin"
                    style={{ padding: "8px", overflowY: "scroll" }}
                  >
                    <div className="col-md-12">
                      <div className="row">
                        <form>
                          <div className="col-sm-3">
                            <input
                              type="text"
                              onChange={(e) => setSearch_UserId(e.target.value)}
                              value={Search_UserId}
                              className="form-control"
                              placeholder="Enter User Id, Mobile Or Email"
                              style={{ border: "1px solid silver" }}
                            />
                          </div>
                          <div className="col-sm-1">
                            <input
                              type="button"
                              id="btnsearch"
                              onClick={() => referral_API()}
                              className="btn btn-lg btn-primary"
                              value="Search"
                            />
                          </div>
                          <div className="col-sm-3">
                            <input
                              type="button"
                              id="btnsearch"
                              onClick={() => referral_API_Export()}
                              className="btn btn-lg btn-primary"
                              value="Export To Excel"
                            />
                          </div>
                        </form>

                        <div
                          className="col-sm-4"
                          style={{ "margin-top": "10px" }}
                        >
                          <h4 className="panel-title">
                            Total Requested Amount : {TotalBet}
                          </h4>
                        </div>
                        {/* <div className="col-sm-6">
                          <input
                            type="text"
                            onChange={(e) => setReason(e.target.value)}
                            value={reason}
                            className="form-control"
                            placeholder="Enter Remark"
                            style={{ border: "1px solid silver" }}
                          />
                        </div> */}
                      </div>

                      <div className="row">
                        <div className="panel-heading">
                          <h4 className="panel-title"></h4>
                        </div>
                        <div
                          className="table-responsive"
                          data-pattern="priority-columns"
                          style={{ maxHeight: "500px", overflow: "scroll" }}
                        >
                          <Table
                            data={currentPostleft}
                            columns={my_team.cols}
                          />

                          <Table_Buttons
                            indexOfFirstPage={indexOfFirstPage}
                            indexOfLastPost={indexOfLastPost}
                            setcurrentPage={setcurrentPage}
                            currentPage={currentPage}
                            totalData={leftreferralApi.length}
                            listPerpage={listPerpage}
                            handleRowsPerPageChange={setlistPerpage}
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>) : (
        <>
          <div class="content-page">
            <div class="content">
              <div class="row">
                <div class="col-md-12">
                  <div class="panel panel-primary">
                    <div class="panel-heading">
                      <h4 class="panel-title">Pending Wallet Change Request</h4>
                    </div>
                    <div className="text-center mt-5">
                      <h3>You are not authorized to access this page.</h3>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </>
      )}
    </div>
  );
}

export default PendingUsdtRequest;
